import gql from 'graphql-tag';

export const GET_LENDER_PERFORMANCE_TREND = gql`
  query LenderPerformanceTrend($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      trend(input: $input) {
        success
        error
        entity {
          month
          approvalRate
          fundRate
          lookToBook
        }
      }
    }
  }
`;
